module.exports = __webpack_public_path__ + "static/media/mz.780f4859.svg";